import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppHeaderProps, ChargePerReelModalState, LayoutState } from '../../types/layout/layoutTypes';
import { PURGE } from 'redux-persist';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { set } from 'lodash';
import { platforms } from '../../constants/constants';

const initialState: LayoutState = {
    profile_update_modal_visibility: false,
    main_menu_visibility: false,
    page_title: '',
    intended_path: '/',
    selected_post_id: null,
    bg_white: false,
    address_selection_modal_visibility: false,
    showFooterNav: true,
    collabSupport: {
        visibility: {
            icon: false,
            popup: false
        }
    },
    showHeader: true,
    selectedSocialPost: null,
    location_update_modal_visibility: false,
    add_social_account_modal_visibility: {
        active: false,
        platforms: Object.values(platforms)
    },
    enable_notifications_popup_visibility: false,
    header: {
        generic: true,
        hidden: false
    },
    pro_features_modal_visibility: false,
    charge_per_reel_modal: {
        active: false,
        socialAccount: null,
        prefill: undefined
    }
};

const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        toggleMainMenu: (state, action: PayloadAction<boolean>) => {
            state.main_menu_visibility = action.payload
        },
        toggleProfileUpdateModal: (state, action: PayloadAction<boolean>) => {
            state.profile_update_modal_visibility = action.payload;
        },
        toggleLocationUpdateModal: (state, action: PayloadAction<boolean>) => {
            state.location_update_modal_visibility = action.payload;
        },
        setPageTitle: (state, action: PayloadAction<string>) => {
            state.page_title = action.payload;
        },
        setIntendedPath: (state, action: PayloadAction<string>) => {
            state.intended_path = action.payload;
        },
        setSelectedPost: (state, action: PayloadAction<string | null>) => {
            state.selected_post_id = action.payload;
        },
        setBGWhite: (state, action: PayloadAction<boolean>) => {
            state.bg_white = action.payload;
        },
        toggleAddressSelectionModal: (state, action: PayloadAction<boolean>) => {
            state.address_selection_modal_visibility = action.payload;
        },
        toggleAddSocialAccountModal: (state, action: PayloadAction<{ platforms?: { id: string, name: string }[], active: boolean }>) => {
            state.add_social_account_modal_visibility.active = action.payload.active;
            state.add_social_account_modal_visibility.platforms = action.payload.platforms ?? Object.values(platforms);
        },
        setShowFooterNav: (state, action: PayloadAction<boolean>) => {
            state.showFooterNav = action.payload;
        },
        setCollabSupport: (state, { payload }) => {
            state.collabSupport = payload;
        },
        showHeader: (state, { payload }) => {
            state.showHeader = payload;
        },
        setSelectedSocialPost: (state, action: PayloadAction<{ socialPostId: string, socialAccountId: string } | null>) => {
            state.selectedSocialPost = action.payload;
        },
        setEnableNotificationsPopupVisibility: (state, action: PayloadAction<boolean>) => {
            state.enable_notifications_popup_visibility = action.payload;
        },
        setHeader: (state, action: PayloadAction<AppHeaderProps | null>) => {
            state.header = action.payload;
        },
        setProFeaturesModalVisibility: (state, action: PayloadAction<boolean>) => {
            state.pro_features_modal_visibility = action.payload;
        },
        setChargePerReelModal: (state, action: PayloadAction<ChargePerReelModalState>) => {
            state.charge_per_reel_modal = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => {
            return initialState;
        });
    }
});

export const {
    toggleProfileUpdateModal,
    toggleMainMenu,
    setPageTitle,
    showHeader,
    setIntendedPath,
    setSelectedPost,
    setBGWhite,
    toggleAddressSelectionModal,
    setShowFooterNav,
    setCollabSupport,
    setSelectedSocialPost,
    toggleLocationUpdateModal,
    toggleAddSocialAccountModal,
    setEnableNotificationsPopupVisibility,
    setHeader,
    setProFeaturesModalVisibility,
    setChargePerReelModal
} = layoutSlice.actions;

export default persistReducer({
    key: 'app',
    storage,
    whitelist: ['intended_path']
}, layoutSlice.reducer);